import { useForm } from 'react-hook-form';
import { Button, Field, Input } from '../../components/ui';
import { ApiError } from '../../lib/api';
import { useT } from '../../lib/i18n';
import LanguageToggle from '../../components/LanguageToggle';
import { useLogin } from './api';

interface LoginValues {
  email: string;
  password: string;
}

export default function LoginPage() {
  const t = useT();
  const login = useLogin();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginValues>({ defaultValues: { email: '', password: '' } });

  const onSubmit = handleSubmit((values) => login.mutate(values));
  const serverError = login.error as ApiError | null;

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50 dark:bg-zinc-950 p-4">
      <div className="w-full max-w-sm">
        <div className="mb-7 flex flex-col items-center text-center">
          <span className="grid h-12 w-12 place-items-center rounded-xl bg-zinc-900 text-zinc-100 text-xl font-bold dark:bg-zinc-100 dark:text-zinc-900">S</span>
          <h1 className="mt-3 text-lg font-semibold tracking-[0.04em]">STUDIO OS</h1>
          <p className="text-[11px] tracking-[0.18em] text-zinc-400">VÝROBA · PŮJČOVNA</p>
          <div className="mt-4 flex justify-center"><LanguageToggle /></div>
        </div>

        <form
          onSubmit={onSubmit}
          className="space-y-4 rounded-xl border border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-900 p-6 shadow-sm"
        >
          <p className="text-center text-sm text-zinc-500">{t('Přihlášení do interní aplikace')}</p>
          <Field label={t('E-mail')} htmlFor="email" error={errors.email?.message}>
            <Input
              id="email"
              type="email"
              autoFocus
              autoComplete="username"
              {...register('email', { required: 'Zadej e-mail' })}
            />
          </Field>

          <Field label={t('Heslo')} htmlFor="password" error={errors.password?.message}>
            <Input
              id="password"
              type="password"
              autoComplete="current-password"
              {...register('password', { required: 'Zadej heslo' })}
            />
          </Field>

          {serverError && (
            <p className="text-sm text-red-600 dark:text-red-400">{serverError.message}</p>
          )}

          <Button type="submit" className="w-full" disabled={login.isPending}>
            {login.isPending ? t('Přihlašuji…') : t('Přihlásit se')}
          </Button>
        </form>
      </div>
    </div>
  );
}
